import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  rowContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 40,
    flexWrap: 'wrap',
    margin: '20px 0px 0 30px',
  },
});
